import styled, { css } from 'styled-components';

import { SonntagButtonV2 } from '@getgrover/ui';

import FrontshopLink from 'ggApp/shared/containers/FrontshopLink';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 120px;
`;

const Button = styled(SonntagButtonV2)`
    margin-top: ${({ theme }) => theme.spacers.L};

`;

const Link = styled(FrontshopLink)``;

const Image = styled.img`
    height: auto;
    width: 350px;
`;

const Subheadline = styled.p`
    margin-top: ${({ theme }) => theme.spacers.XXL};
    ${({ theme }) => css(theme.typography.Subheadline)};
    color: ${props => props.theme.colors.Foreground};
    text-align: center;
`;

export {
    Container,
    Image,
    Subheadline,
    Button,
    Link,
};
